// src/components/ui/card.js (or .tsx)
export const Card = ({ children }) => {
    return <div className="card">{children}</div>;
  };
  
  export const CardContent = ({ children }) => {
    return <div className="card-content">{children}</div>;
  };
  